import AboutSection from "../components/AboutSection";
import AgeBanner from "../components/AgeBanner";
import DisclaimerBanner from "../components/DisclaimerBanner";
import FeaturesSection from "../components/FeaturesSection";
import Footer from "../components/Footer";
import GameSection from "../components/GameSection";
import HeroSection from "../components/HeroSection";
import Navigation from "../components/Navigation";
import { usePageTitle } from "../hook/usePageTitle";

const HomePage = () => {
  usePageTitle();
  return (
    <>
      <AgeBanner />
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <GameSection />
      <AboutSection />
      <DisclaimerBanner />
      <Footer />
    </>
  );
};

export default HomePage;


